import { IUsersData, ICreateUsersResponse } from 'types/users';
import api from '../services/config/api';

export const editUser = (id: string, data: IUsersData) =>
  api.put<ICreateUsersResponse>(`/user/${id}`, data);
